/**
 * Controls how `Duration.format()` displays a duration value.
 *
 * The edit/parse behavior of `DurationInput`/`DurationInlineInput` is unaffected —
 * users can still type "1d 2h", "3h", "180m" regardless of the selected mode. This
 * enum only changes the display (read-only) formatting.
 */
export enum DisplayAs {
  /** Always total minutes — e.g. "180m", "1440m". No workday config applied. */
  Minutes = 'minutes',
  /** Hours + remainder minutes — e.g. "3h", "2h 30m", "180h 15m". No workday config applied. Default. */
  Hours = 'hours',
  /** Days + hours + minutes — e.g. "1d 1h", "2d", "3h 30m". Uses workday hoursPerDay. */
  Days = 'days',
  /** Weeks + days + hours + minutes — e.g. "1w 2d 3h". Uses workday hoursPerDay and daysPerWeek. */
  Weeks = 'weeks',
  /** Months + weeks + days + hours + minutes — e.g. "9mo 1d". Uses workday config and a fixed 4 weeks / month. */
  Months = 'months',
}
